/**
 * LegalPageLayout Component
 * Shared layout for legal pages (Terms, Privacy) with modern Navbar and Footer
 */

import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const LegalPageLayout = ({ children, title, effectiveDate, description }) => {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      
      <main className="pt-24 pb-16">
        {/* Header Section */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
          <div className="text-center">
            <span className="inline-block px-4 py-2 bg-indigo-100 text-indigo-600 font-semibold text-sm rounded-full mb-6">
              Legal
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy mb-6">
              {title}
            </h1>
            <div className="flex flex-wrap items-center justify-center gap-4 text-muted mb-8">
              <span className="px-4 py-2 bg-soft border border-line rounded-full text-sm">
                Last updated: {effectiveDate}
              </span>
              <span className="text-sm">Effective: {effectiveDate}</span>
            </div>
          </div>

          {/* Description Box */}
          <div className="bg-gradient-to-br from-soft to-white p-8 rounded-2xl border border-line shadow-sm">
            <p className="text-lg text-muted leading-relaxed">
              {description}
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalPageLayout;
